import $ from 'jquery'

/**
 * Adapter for the select2 constructor
 * @param {HTMLSelectElement} select - The select element to enhance
 * @returns {void}
 */
export default (select) => {
  $(select).select2()
}
